﻿/*
Class: OpaccArticlePrice
Description: Price handling
*/

import { opaccAjaxPlugin, opaccLocalStoragePlugin } from './vendor/script/opacc.static.js';
import { formatDate } from './opacc.common.js';


export class OpaccArticleStock {
    constructor(selector = "[data-article-async-stock]", urlID = "article-stock-url") {
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';
        this.selector = selector;
        const urlElement = document.getElementById(urlID);
        if(urlElement && urlElement.getAttribute('data-op-url')) {
            this.articleStockUrl = urlElement.getAttribute('data-op-url');
            this.collectData();
        }
    }

    collectData() {
        this.artInternalNumbers = [];
        const wrappers = document.querySelectorAll(`${this.selector}[data-op-status="pending"]`);
        Array.from(wrappers).forEach(wrapper => {
            if (wrapper.getAttribute('data-op-art-internalno')) {
                this.artInternalNumbers.push(wrapper.getAttribute('data-op-art-internalno'));
                wrapper.setAttribute('data-op-status', 'loading');
            }
            this.isSmall = wrapper.hasAttribute('data-stock-size-is-small');
        });

        if(this.artInternalNumbers.length > 0) {
            this.loadStock();
        }
    }

    loadStock() {
        const currentDate = new Date();

        const artInternalNoString = `${this.artInternalNumbers}`;
        let data = {
            artInternalNos: artInternalNoString,
            stockIsSmall: this.isSmall
        }


        opaccAjaxPlugin.fetchAsynPostForm(this.articleStockUrl, data, this.showStock.bind(this), opaccAjaxPlugin.getDefaultErrorFnc, true);
    }

    showStock(response) {
        const data = response.dataAsJson;
        Array.from(data.stock).forEach(stockInfo => {
            const wrappers = document.querySelectorAll(`${this.selector}[data-op-art-internalno="${stockInfo.artIntNo}"]`);
            Array.from(wrappers).forEach(wrapper => {
                wrapper.innerHTML = this.htmlDecode(stockInfo.text);
                wrapper.setAttribute('data-op-status', 'done');
            });
        });

        let resultWrapperSelector = '.result-view-wrapper';
		if (document.querySelector(resultWrapperSelector)) {
            if(document.querySelector(this.buttonElementSelector)) {
                opaccLocalStoragePlugin.setPersistentView(opaccLocalStoragePlugin.getCurrentURI(), resultWrapperSelector, this.buttonElementSelector);
            } else {
                opaccLocalStoragePlugin.setPersistentView(opaccLocalStoragePlugin.getCurrentURI(), resultWrapperSelector);
            }
        }
    }

    htmlDecode(input){
        if(!this.shadowPlaceholder) {
            this.shadowPlaceholder = document.createElement('div');
        } else {
            this.shadowPlaceholder.innerHTML = '';
        }
        this.shadowPlaceholder.innerHTML = input;
        return this.shadowPlaceholder.childNodes[0].nodeValue;
      }
}

